import { render, staticRenderFns } from "./ProjectDocumentTemplateDetailEditForm.vue?vue&type=template&id=0beb26d2"
import script from "./ProjectDocumentTemplateDetailEditForm.vue?vue&type=script&lang=js"
export * from "./ProjectDocumentTemplateDetailEditForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports